const reportDB = require('../../../../../components/report/report-db')
const report = require('../../../../../components/report/report')
const style = require('../../../../../components/report/report-style')
const css = style.get()
const settings = require('../../../../../js-handler/settings')
const timeDate = require('../../../../../js-handler/time-date')
const timeTime = require('../../../../../js-handler/time-time')
const math = require('../../../../../js-handler/math')

export function start(detail) {

    const phpFile = 'server/php/sql/report.php'

    if (detail.source == 'fullcont') {
        const fullcontProvider = document.getElementById('provider-fullcont')
        let dataDbid = '';

        dataDbid = fullcontProvider.getAttribute('data-dbid')
        detail.inf = { entity: 'provider', report: 'account-all-profit', id: dataDbid }

        reportDB.select(detail, phpFile, (data) => {

            insert(detail, data)

        })
    } else if (detail.source == 'dt') {
        let dataDbid = '';
        dataDbid = detail.dbid
        detail.inf = { entity: 'provider', report: 'account-all-profit', id: dataDbid }

        reportDB.select(detail, phpFile, (data) => {

            insert(detail, data)

        })
    } else {
        detail.inf = { entity: 'provider', report: 'account-all-profit' }

        reportDB.select(detail, phpFile, (data) => {

            insert(detail, data)

        })
    }

}/**/

function insert(detail, data) {

    report.show(detail, () => {

        const pageTarget = document.getElementById('report-page-right')
        const body = generate(data)

        pageTarget.insertAdjacentHTML("beforeend", body)

    })

}/*insert*/


function generate(data) {

    var body = ''
    body += generateHeader()
    body += generateTop(data)
    body += generateTable(data)
    body += `</div> <!-- dataCont -->`
    body += `<div class="report-page">`

    return body
}

function generateHeader() {

    var header = ''
    header += `<div class="report-page" id="miDiv5" ${css.table}>`
    header += `
                    <div class="report-appbar report-appbar-black" >

                            <div  data-detail='{"click": [ 
                                                        {"dest":"ripple" }, 
                                                        {"dest":"report", "act":"remove" } ] }' >
                                <svg><use xlink:href="../css/svg.svg#close"></use></svg>
                            </div>

                            <h1>All Providers Statement: Provider Profit Aging Report</h1>

                        <div class="fr" data-detail='{"click": [ 
                                                    {"dest":"ripple" }, 
                                                    {"dest":"report", "act":"print" }  ] }' >
                                <svg><use xlink:href="../css/svg.svg#print"></use></svg>
                                <label>Print</label>
                        </div>
                    </div> <!-- appbar -->
            `

    header += `
                    <div class="dataCont">
                        <h1  ${css.f32}></h1>
                        <p   ${css.f14} >
                                
                        </p>
            `
    return header


}


function generateTop(data) {

    let company_name = "";
    let current_dateTime = "";

    //if no data found
    if (data.length > 0) {
        company_name = data[0].company_name;
        current_dateTime = data[0].current_dateTime;
    } else {
        let config = settings.getData()
        company_name = config.company;
        current_dateTime = timeDate.getdateshort() + ' ' + timeTime.formatAMPM();
    }

    var table = `<br><br><h1 style="text-align: center;">${company_name}</h1>
      <h2 style="text-align: center;">Accounts Profits All Report: As Of ${current_dateTime}</h2>
      <h2 style="text-align: center;"></h2>
      `;


    return table

}/**/

function generateTable(data) {
    var totals = {
        total_last_24_hours: 0, total_last_24_hours_income: 0,
        total_last_7_days: 0, total_last_7_days_income: 0,
        total_last_15_days: 0, total_last_15_days_income: 0,
        total_last_30_days: 0, total_last_30_days_income: 0,
        total_last_90_days: 0, total_last_90_days_income: 0,
        total_over_90_days: 0, total_over_90_days_income: 0,
        grandTotal: 0
    };
    var nextFormat = 0;

    // Función auxiliar para limpiar datos de forma segura
    const cleanVal = (val) => {
        if (val === undefined || val === null) return 0;
        const cleaned = String(val).replace(/[$,]/g, '');
        return parseFloat(cleaned) || 0;
    };

    var table = `
    <h2 ${css.f15}>Providers Vs Profits: This is a financial document that provides a summary of earning that a company earned to its suppliers or vendors.</h2>
    <table ${css.table} class="dt-alterColor">
     <tr>
       <th ${css.th}>provider</th>
       <th ${css.th}>Last 24 hours</th>
       <th ${css.th}>Last 7 days</th>
       <th ${css.th}>Last 15 days</th>
       <th ${css.th}>Last 30 days</th>
       <th ${css.th}>Last 90 days</th>
       <th ${css.th}>Over 90 days</th>
       <th ${css.th}>Total</th>   
     </tr>`;

    if (data.length == 0) {
        table += `<tr><td ${css.td} colspan="8"><div align="center"><h3>No Profits Were Found.</h3></div></td></tr></table>`;
        return table;
    }

    for (let i = 0; i < data.length; i++) {
        const item = data[i];

        // Procesar valores de forma segura
        const v24h = cleanVal(item.last_24_hours), inc24h = cleanVal(item.last_24_hours_income);
        const v7d = cleanVal(item.last_7_days), inc7d = cleanVal(item.last_7_days_income);
        const v15d = cleanVal(item.last_15_days), inc15d = cleanVal(item.last_15_days_income);
        const v30d = cleanVal(item.last_30_days), inc30d = cleanVal(item.last_30_days_income);
        const v90d = cleanVal(item.last_90_days), inc90d = cleanVal(item.last_90_days_income);
        const vOver = cleanVal(item.over_90_days), incOver = cleanVal(item.over_90_days_income);
        const vTotal = cleanVal(item.total_earnings);

        // Acumular totales
        totals.total_last_24_hours += v24h; totals.total_last_24_hours_income += inc24h;
        totals.total_last_7_days += v7d; totals.total_last_7_days_income += inc7d;
        totals.total_last_15_days += v15d; totals.total_last_15_days_income += inc15d;
        totals.total_last_30_days += v30d; totals.total_last_30_days_income += inc30d;
        totals.total_last_90_days += v90d; totals.total_last_90_days_income += inc90d;
        totals.total_over_90_days += vOver; totals.total_over_90_days_income += incOver;
        totals.grandTotal += vTotal;

        // Crear strings de atributos dinámicos
        const detail = (val, period) => val > 0 ? `class='tdClick' data-detail='{"click": [ {"dest":"ripple" }, {"dest":"provider", "elem":"report", "reportType":"profitPeriod", "entity":"provider", "dbid":"${item.provider_id}", "source":"dt", "period":"${period}" } ] }'` : '';

        table += `
            <tr ${rowStyle(i)}>
                <td ${css.td}>${item.provider_name || 'N/A'}</td>
                <td ${css.td} ${detail(v24h, 1)}>${item.last_24_hours_income}<br>${item.last_24_hours}<br><small>${math.percentFormat(safePercentage(v24h, inc24h))}</small></td>
                <td ${css.td} ${detail(v7d, 2)}>${item.last_7_days_income}<br>${item.last_7_days}<br><small>${math.percentFormat(safePercentage(v7d, inc7d))}</small></td>
                <td ${css.td} ${detail(v15d, 3)}>${item.last_15_days_income}<br>${item.last_15_days}<br><small>${math.percentFormat(safePercentage(v15d, inc15d))}</small></td>
                <td ${css.td} ${detail(v30d, 4)}>${item.last_30_days_income}<br>${item.last_30_days}<br><small>${math.percentFormat(safePercentage(v30d, inc30d))}</small></td>
                <td ${css.td} ${detail(v90d, 5)}>${item.last_90_days_income}<br>${item.last_90_days}<br><small>${math.percentFormat(safePercentage(v90d, inc90d))}</small></td>
                <td ${css.td} ${detail(vOver, 6)}>${item.over_90_days_income}<br>${item.over_90_days}<br><small>${math.percentFormat(safePercentage(vOver, incOver))}</small></td>
                <td ${css.td}>${cashVal(vTotal)}</td>
            </tr>`;
        nextFormat = i + 1;
    }

    // Cálculo de porcentajes de totales y cierre de tabla
    totals.total_last_24_hours_percent = safePercentage(totals.total_last_24_hours, totals.total_last_24_hours_income);
    totals.total_last_7_days_percent = safePercentage(totals.total_last_7_days, totals.total_last_7_days_income);
    totals.total_last_15_days_percent = safePercentage(totals.total_last_15_days, totals.total_last_15_days_income);
    totals.total_last_30_days_percent = safePercentage(totals.total_last_30_days, totals.total_last_30_days_income);
    totals.total_last_90_days_percent = safePercentage(totals.total_last_90_days, totals.total_last_90_days_income);
    totals.total_over_90_days_percent = safePercentage(totals.total_over_90_days, totals.total_over_90_days_income);

    table += `
        <tr ${rowStyle(nextFormat)}>
          <td style="text-align: right;"><h2>Total</h2></td>
          <td ${css.td}><h5>${cashVal(totals.total_last_24_hours_income)}<br>${cashVal(totals.total_last_24_hours)}<br>${math.percentFormat(totals.total_last_24_hours_percent)}</h5></td>
          <td ${css.td}><h5>${cashVal(totals.total_last_7_days_income)}<br>${cashVal(totals.total_last_7_days)}<br>${math.percentFormat(totals.total_last_7_days_percent)}</h5></td>
          <td ${css.td}><h5>${cashVal(totals.total_last_15_days_income)}<br>${cashVal(totals.total_last_15_days)}<br>${math.percentFormat(totals.total_last_15_days_percent)}</h5></td>
          <td ${css.td}><h5>${cashVal(totals.total_last_30_days_income)}<br>${cashVal(totals.total_last_30_days)}<br>${math.percentFormat(totals.total_last_30_days_percent)}</h5></td>
          <td ${css.td}><h5>${cashVal(totals.total_last_90_days_income)}<br>${cashVal(totals.total_last_90_days)}<br>${math.percentFormat(totals.total_last_90_days_percent)}</h5></td>
          <td ${css.td}><h5>${cashVal(totals.total_over_90_days_income)}<br>${cashVal(totals.total_over_90_days)}<br>${math.percentFormat(totals.total_over_90_days_percent)}</h5></td>
          <td ${css.td}><h4>${cashVal(totals.grandTotal)}</h4></td>
        </tr></table>`;

    return table;
}

function safePercentage(numerator, denominator) {
    if (!denominator || denominator === 0 || isNaN(denominator)) {
        return "0.00"; // Retorna un valor predeterminado si el denominador no es válido
    }

    if (!numerator || isNaN(numerator)) {
        numerator = 0; // Asegura que el numerador no sea `null` o `NaN`
    }

    return parseFloat((numerator / denominator) * 100).toFixed(2);
}

function cashVal(value) {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}


function rowStyle(i) {

    if (i % 2 === 0) { return '' }
    return css.trGray

}
